"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BreadcrumbLink = _ref => {
  let {
    label,
    url,
    icon,
    navigationHandler,
    index,
    isActive,
    ...rest
  } = _ref;
  const ariaAttributes = {};
  if (isActive) {
    ariaAttributes['aria-current'] = 'page';
  }
  if (typeof navigationHandler !== 'undefined') {
    return /*#__PURE__*/_react.default.createElement("a", {
      role: "button",
      onClick: navigationHandler ? () => navigationHandler(index) : () => {}
    }, icon && /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons",
      "aria-hidden": "true"
    }, icon)), label);
  }
  if (url && !url.startsWith('http') && url !== '#') {
    /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: {
        url,
        state: {
          ...rest
        }
      }
    }, icon && /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons",
      "aria-hidden": "true"
    }, icon)), label);
  }
  return /*#__PURE__*/_react.default.createElement("a", _extends({
    href: url || '#'
  }, ariaAttributes), icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon is-small"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    "aria-hidden": "true"
  }, icon)), label);
};
BreadcrumbLink.propTypes = {
  label: _propTypes.default.string.isRequired,
  url: _propTypes.default.string,
  icon: _propTypes.default.string,
  navigationHandler: _propTypes.default.func,
  index: _propTypes.default.number,
  isActive: _propTypes.default.bool
};
const Breadcrumb = _ref2 => {
  let {
    id,
    items,
    navigationHandler,
    className,
    separator,
    size,
    align,
    containerClassName,
    isHiddenMobile,
    hasMargin
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id || 'breadcrumb-container-1',
    className: `${containerClassName ? 'containerClassName' : 'breadcrumb-container'} ${isHiddenMobile ? 'is-hidden-mobile' : ''} ${hasMargin ? 'mt-2 mb-2' : ''}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "breadcrumb-wrapper"
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: `breadcrumb ${className || ''} ${separator ? `has-${separator}-separator` : ''} ${size ? `is-${size}` : ''} ${align ? `is-${align}` : ''}`,
    "aria-label": "breadcrumb",
    role: "navigation"
  }, /*#__PURE__*/_react.default.createElement("ul", null, items && items.length > 0 && items.map((item, index) => {
    const isActive = index === items.length - 1;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: `item_${item.label}_${index}`,
      className: isActive ? 'is-active' : ''
    }, /*#__PURE__*/_react.default.createElement(BreadcrumbLink, {
      url: item.url,
      icon: item.icon,
      label: item.label,
      navigationHandler: navigationHandler,
      index: index,
      isActive: isActive
    }));
  })))));
};
Breadcrumb.propTypes = {
  id: _propTypes.default.string,
  hasMargin: _propTypes.default.bool,
  isHiddenMobile: _propTypes.default.bool,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    url: _propTypes.default.string,
    icon: _propTypes.default.string
  })).isRequired,
  className: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  navigationHandler: _propTypes.default.func,
  separator: _propTypes.default.oneOf(['default', 'arrow', 'bullet', 'dot', 'succeeds']),
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['default', 'small', 'medium', 'large']), _propTypes.default.string]),
  align: _propTypes.default.oneOf(['default', 'left', 'right', 'centered'])
};
Breadcrumb.defaultProps = {
  items: [],
  active: {
    label: ''
  },
  isHiddenMobile: true,
  hasMargin: true
};
var _default = exports.default = Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map